import Slider from 'react-slick';
import { Link } from "react-router-dom";
import ConImg from '../../public/assets/images/bg/conference.jpg';
import { NextArrow, PrevArrow } from "../Arrows";
import CustomButton from '../CustomButton';

function NextEvent({ lastconference }) {

    if (!lastconference || lastconference.length === 0) {
        return null;
    }

    const settings = {
        dots: false,
        infinite: true,
        speed: 1000,
        slidesToShow: 2,
        autoplay: true,
        slidesToScroll: 1,
        arrows: true,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        draggable: false,
        swipe: true,
        touchMove: true,
        responsive: [
            {
                breakpoint: 991,
                settings: { slidesToShow: 1, }
            },
            {
                breakpoint: 480,
                settings: { slidesToShow: 1, }
            }
        ]
    };

    const Calendar = (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path fill="currentColor" d="M7.288 13.713Q7 13.425 7 13t.288-.712T8 12t.713.288T9 13t-.288.713T8 14t-.712-.288m4 0Q11 13.426 11 13t.288-.712T12 12t.713.288T13 13t-.288.713T12 14t-.712-.288m4 0Q15 13.426 15 13t.288-.712T16 12t.713.288T17 13t-.288.713T16 14t-.712-.288M5 22q-.825 0-1.412-.587T3 20V6q0-.825.588-1.412T5 4h1V2h2v2h8V2h2v2h1q.825 0 1.413.588T21 6v14q0 .825-.587 1.413T19 22zm0-2h14V10H5zM5 8h14V6H5zm0 0V6z" />
        </svg>
    );

    const Location = (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g fill="none">
                <path d="M12 2a8 8 0 0 1 8 8c0 6.5-8 12-8 12s-8-5.5-8-12a8 8 0 0 1 8-8m0 5a3 3 0 1 0 0 6a3 3 0 0 0 0-6" clipRule="evenodd" />
                <path stroke="currentColor" strokeWidth="2" d="M20 10c0 6.5-8 12-8 12s-8-5.5-8-12a8 8 0 1 1 16 0Z" />
                <path stroke="currentColor" strokeWidth="2" d="M15 10a3 3 0 1 1-6 0a3 3 0 0 1 6 0Z" />
            </g>
        </svg>
    );

    return (
            <>
            <div className="conference-section mb-100" data-aos="fade-up">
                <div className="container">
                    <div className="section-title2 primary3 text-start">
                        <span>upcoming event</span>
                            <h2>Next Events</h2>
                    </div>
                    <div className="con-wrap">
                        <Slider {...settings}>
                            {lastconference && lastconference.map((info, index) => (
                                <div key={index}>
                                <div className="con-item glass-effect">
                                    <div className="con-image-section">
                                        <div className="image">
                                            <img src={info.image || ConImg} alt="conference-img" className="img-fluid" />
                                        </div>
                                         {/* <span className="tag">{info.tag || "Registration Open"}</span> */}
                                    </div>
                                    <div className="con-data-section">
                                        <div className='con-detail-wrap'>
                                            <div className="row">
                                                <div className="col-md-8 col-12">
                                                    <div className="detail-data">
                                                        {/* <p className="invite">{info.invite}</p> */}
                                                        <div className="section-title2 primary3 text-start">
                                                            <h2 className="title">{info.conference_name}</h2>
                                                        </div>
                                                        <p className="subtitle">{info.short_description}</p>
                                                        {/* <p className="desc">{info.description}</p> */}
                                                        <div className="conference-details">
                                                            <div className="date">{Calendar}{info.start_date_edit} - {info.end_date_edit}</div>
                                                            <div className="location">{Location}{info.venue_name}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 col-12">
                                                    <div className="highlights-data">
                                                        <p className="title">Conference Highlights</p>
                                                        <ul className="highlights">
                                                            {info.description?.split(/\r?\n/).map((item, i) => (
                                                                <li key={i}>{item}</li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="conference-actions">
                                                <button className="eg-btn btn--primary2 capsule">{info.button_text}<CustomButton /></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </div>
                            ))}
                        </Slider>
    
    
                    </div>
                </div>
            </div>
            </>
        );
    };
    
export default NextEvent;